import { Component, Input, WritableSignal, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClientConfiguration } from 'src/app/shared/models/clientConfiguration';
import { User } from 'src/app/shared/models/user';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss'],
})
export class UpdateUserComponent {
  @Input() excelSingleSpreadsheet: WritableSignal<boolean> = signal(false);
  @Input() userId!: string;
  user?: User;
  logoSignal = signal<string | undefined>(undefined)
  emailSignal = signal<string | undefined>(undefined)
  websiteSignal = signal<string | undefined>(undefined)

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
  ) { }

  async ngOnInit() {
    this.userId = this.route.snapshot.paramMap.get('userId')!;

    this.user = await this.userService.getUser(this.userId);
    this.logoSignal.set(this.user.client?.configuration?.customLogo);
    this.emailSignal.set(this.user.client?.configuration?.customEmail);
    this.websiteSignal.set(this.user.client?.configuration?.customWebSite);
    this.excelSingleSpreadsheet.set(this.user.client?.configuration?.excelSingleSpreadsheet ?? false);
  }

  async onSave() {
    const configuration: ClientConfiguration = {
      customLogo: this.logoSignal(),
      customEmail: this.emailSignal(),
      customWebSite: this.websiteSignal(),
      excelSingleSpreadsheet: this.excelSingleSpreadsheet(),
    }
    await this.userService.updateUser(this.user!.id, configuration);
  }

  excelSingleSpreadsheetCheckedChanged(event: any) {
    this.excelSingleSpreadsheet.set(event.target.checked);
  }
}
